module.exports = {
  src: __webpack_public_path__ + "assets/images/windows_icon.cdb1fc12d2e7bb5a.svg",
  width: 24,
  height: 24,
  toString: function() { return __webpack_public_path__ + "assets/images/windows_icon.cdb1fc12d2e7bb5a.svg"; }
};